const size_guide_data = [
    {
        min: 63,
        max: 67,
        size: 65,
        second: [
            {
                min: 75,
                max: 76,
                size: "AA"
            },
            {
                min: 77,
                max: 78,
                size: "A"
            },
            {
                min: 79,
                max: 80,
                size: "B"
            },
            {
                min: 81,
                max: 82,
                size: "C"
            },
            {
                min: 83,
                max: 85,
                size: "D"
            }
        ]
    },
    {
        min: 68,
        max: 72,
        size: 70,
        second: [
            {
                min: 80,
                max: 81,
                size: "AA"
            },
            {
                min: 82,
                max: 83,
                size: "A"
            },
            {
                min: 84,
                max: 85,
                size: "B"
            },
            {
                min: 86,
                max: 87,
                size: "C"
            },
            {
                min: 88,
                max: 89,
                size: "D"
            },
            {
                min: 90,
                max: 91,
                size: "E"
            },
            {
                min: 92,
                max: 94,
                size: "F"
            }
        ]
    },
    {
        min: 73,
        max: 77,
        size: 75,
        second: [
            {
                min: 85,
                max: 86,
                size: "AA"
            },
            {
                min: 87,
                max: 88,
                size: "A"
            },
            {
                min: 89,
                max: 90,
                size: "B"
            },
            {
                min: 91,
                max: 92,
                size: "C"
            },
            {
                min: 93,
                max: 94,
                size: "D"
            },
            {
                min: 95,
                max: 96,
                size: "E"
            },
            {
                min: 97,
                max: 98,
                size: "F"
            },
            {
                min: 99,
                max: 101,
                size: "G"
            }
        ]
    },
    {
        min: 78,
        max: 82,
        size: 80,
        second: [
            {
                min: 90,
                max: 91,
                size: "AA"
            },
            {
                min: 92,
                max: 93,
                size: "A"
            },
            {
                min: 94,
                max: 95,
                size: "B"
            },
            {
                min: 96,
                max: 97,
                size: "C"
            },
            {
                min: 98,
                max: 99,
                size: "D"
            },
            {
                min: 100,
                max: 101,
                size: "E"
            },
            {
                min: 102,
                max: 103,
                size: "F"
            },
            {
                min: 104,
                max: 105,
                size: "G"
            },
            {
                min: 106,
                max: 108,
                size: "H"
            }
        ]
    },
    {
        min: 83,
        max: 87,
        size: 85,
        second: [
            {
                min: 95,
                max: 96,
                size: "AA"
            },
            {
                min: 97,
                max: 98,
                size: "A"
            },
            {
                min: 99,
                max: 100,
                size: "B"
            },
            {
                min: 101,
                max: 102,
                size: "C"
            },
            {
                min: 103,
                max: 104,
                size: "D"
            },
            {
                min: 105,
                max: 106,
                size: "E"
            },
            {
                min: 107,
                max: 108,
                size: "F"
            },
            {
                min: 109,
                max: 110,
                size: "G"
            },
            {
                min: 111,
                max: 113,
                size: "H"
            }
        ]
    },
    {
        min: 88,
        max: 92,
        size: 90,
        second: [
            {
                min: 100,
                max: 101,
                size: "AA"
            },
            {
                min: 102,
                max: 103,
                size: "A"
            },
            {
                min: 104,
                max: 105,
                size: "B"
            },
            {
                min: 106,
                max: 107,
                size: "C"
            },
            {
                min: 108,
                max: 109,
                size: "D"
            },
            {
                min: 110,
                max: 111,
                size: "E"
            },
            {
                min: 112,
                max: 113,
                size: "F"
            },
            {
                min: 114,
                max: 115,
                size: "G"
            },
            {
                min: 116,
                max: 118,
                size: "H"
            }
        ]
    },
    {
        min: 93,
        max: 97,
        size: 95,
        second: [
            {
                min: 105,
                max: 106,
                size: "AA"
            },
            {
                min: 107,
                max: 108,
                size: "A"
            },
            {
                min: 109,
                max: 110,
                size: "B"
            },
            {
                min: 111,
                max: 112,
                size: "C"
            },
            {
                min: 113,
                max: 114,
                size: "D"
            },
            {
                min: 115,
                max: 116,
                size: "E"
            },
            {
                min: 117,
                max: 118,
                size: "F"
            },
            {
                min: 119,
                max: 120,
                size: "G"
            },
            {
                min: 121,
                max: 123,
                size: "H"
            }
        ]
    },
    {
        min: 98,
        max: 102,
        size: 100,
        second: [
            {
                min: 112,
                max: 113,
                size: "A"
            },
            {
                min: 114,
                max: 115,
                size: "B"
            },
            {
                min: 116,
                max: 117,
                size: "C"
            },
            {
                min: 118,
                max: 119,
                size: "D"
            },
            {
                min: 120,
                max: 121,
                size: "E"
            },
            {
                min: 122,
                max: 123,
                size: "F"
            },
            {
                min: 124,
                max: 125,
                size: "G"
            },
            {
                min: 126,
                max: 128,
                size: "H"
            }
        ]
    },
    {
        min: 103,
        max: 107,
        size: 105,
        second: [
            {
                min: 117,
                max: 118,
                size: "A"
            },
            {
                min: 119,
                max: 120,
                size: "B"
            },
            {
                min: 121,
                max: 122,
                size: "C"
            },
            {
                min: 123,
                max: 124,
                size: "D"
            },
            {
                min: 125,
                max: 126,
                size: "E"
            },
            {
                min: 127,
                max: 128,
                size: "F"
            },
            {
                min: 129,
                max: 130,
                size: "G"
            },
            {
                min: 131,
                max: 133,
                size: "H"
            }
        ]
    },
    {
        min: 108,
        max: 112,
        size: 110,
        second: [
            {
                min: 122,
                max: 123,
                size: "A"
            },
            {
                min: 124,
                max: 125,
                size: "B"
            },
            {
                min: 126,
                max: 127,
                size: "C"
            },
            {
                min: 128,
                max: 129,
                size: "D"
            },
            {
                min: 130,
                max: 131,
                size: "E"
            },
            {
                min: 132,
                max: 133,
                size: "F"
            },
            {
                min: 134,
                max: 135,
                size: "G"
            },
            {
                min: 136,
                max: 138,
                size: "H"
            }
        ]
    },
    {
        min: 113,
        max: 117,
        size: 115,
        second: [
            {
                min: 129,
                max: 130,
                size: "B"
            },
            {
                min: 131,
                max: 132,
                size: "C"
            },
            {
                min: 133,
                max: 134,
                size: "D"
            },
            {
                min: 135,
                max: 136,
                size: "E"
            },
            {
                min: 137,
                max: 138,
                size: "F"
            },
            {
                min: 139,
                max: 140,
                size: "G"
            },
            {
                min: 141,
                max: 143,
                size: "H"
            }
        ]
    },
    {
        min: 118,
        max: 122,
        size: 120,
        second: [
            {
                min: 134,
                max: 135,
                size: "B"
            },
            {
                min: 136,
                max: 137,
                size: "C"
            },
            {
                min: 138,
                max: 139,
                size: "D"
            },
            {
                min: 140,
                max: 141,
                size: "E"
            },
            {
                min: 142,
                max: 143,
                size: "F"
            },
            {
                min: 144,
                max: 145,
                size: "G"
            },
            {
                min: 146,
                max: 148,
                size: "H"
            }
        ]
    },
    {
        min: 123,
        max: 127,
        size: 125,
        second: [
            {
                min: 139,
                max: 140,
                size: "B"
            },
            {
                min: 141,
                max: 142,
                size: "C"
            },
            {
                min: 143,
                max: 144,
                size: "D"
            },
            {
                min: 145,
                max: 146,
                size: "E"
            },
            {
                min: 147,
                max: 148,
                size: "F"
            },
            {
                min: 149,
                max: 150,
                size: "G"
            },
            {
                min: 151,
                max: 153,
                size: "H"
            }
        ]
    }
];